/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_12Inputs */

const en_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription export (DocX, and CSV)`)
};

const fr_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de transcription (DocX et CSV)`)
};

const de_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkript-Export (DocX und CSV)`)
};

const it_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione della trascrizione (DocX e CSV)`)
};

const ru_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт транскрипции (DocX и CSV)`)
};

const es_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de transcripciones (DocX y CSV)`)
};

const zh_cn2_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录导出（DocX 和 CSV）`)
};

const ja_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写エクスポート（DocXおよびCSV）`)
};

const hi_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेख निर्यात (DocX और CSV)`)
};

const pt_pt2_signup_feature_pro_12 = /** @type {(inputs: Signup_Feature_Pro_12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação de transcrição (DocX e CSV)`)
};

/**
* | output |
* | --- |
* | "Transcription export (DocX, and CSV)" |
*
* @param {Signup_Feature_Pro_12Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_12 = /** @type {((inputs?: Signup_Feature_Pro_12Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_12Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_12(inputs)
	if (locale === "de") return de_signup_feature_pro_12(inputs)
	if (locale === "it") return it_signup_feature_pro_12(inputs)
	if (locale === "ru") return ru_signup_feature_pro_12(inputs)
	if (locale === "es") return es_signup_feature_pro_12(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_12(inputs)
	if (locale === "ja") return ja_signup_feature_pro_12(inputs)
	if (locale === "hi") return hi_signup_feature_pro_12(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_12(inputs)
	return en_signup_feature_pro_12(inputs)
});